import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "sisal-cookie-consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const save = (thirdParty) => {
    localStorage.setItem(
      KEY,
      JSON.stringify({ necessary: true, thirdParty, ts: Date.now() })
    );
    window.dispatchEvent(new Event("cookie-consent-updated"));
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 32 }}
          transition={{ duration: 0.4, ease: [0.215, 0.61, 0.355, 1] }}
          className="fixed inset-x-3 bottom-24 z-[60] md:bottom-6 md:left-auto md:right-6 md:max-w-md"
        >
          <div className="card-soft p-5">
            <div className="flex items-start gap-3">
              <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-light text-brand-dark">
                <Cookie className="h-4 w-4" />
              </span>
              <div>
                <p className="font-display text-sm font-bold text-ink">Rispettiamo la tua privacy</p>
                <p className="mt-1 text-xs leading-relaxed text-slate-500">
                  Utilizziamo solo cookie tecnici necessari al funzionamento del sito. La mappa di
                  Google Maps viene caricata solo con il tuo consenso. Dettagli nella{" "}
                  <Link to="/cookie-policy" data-testid="cookie-banner-policy-link" className="font-semibold text-brand-dark underline">
                    Cookie Policy
                  </Link>
                  .
                </p>
              </div>
            </div>
            <div className="mt-4 grid grid-cols-2 gap-2">
              <button
                data-testid="cookie-necessary-btn"
                onClick={() => save(false)}
                className="btn btn-outline btn-sm w-full"
              >
                SOLO TECNICI
              </button>
              <button
                data-testid="cookie-accept-btn"
                onClick={() => save(true)}
                className="btn btn-primary btn-sm w-full"
              >
                ACCETTA TUTTO
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
